const minContentButton = document.querySelector('.raffle__min');

const closeMaxContentButton = document.querySelector('.raffle__max__button');

const maxContent = document.querySelector('.raffle__max');

if (minContentButton && closeMaxContentButton && maxContent) {
  // Always start expanded
  maxContent.style.display = 'flex';
  minContentButton.style.display = 'none';

  minContentButton.addEventListener('click', () => {
    maxContent.style.display = 'flex';
    minContentButton.style.display = 'none';
    localStorage.setItem('raffleOpen', 'true');
  });

  closeMaxContentButton.addEventListener('click', () => {
    maxContent.style.display = 'none';
    minContentButton.style.display = 'flex';
    localStorage.setItem('raffleOpen', 'false');
  });
}
